/**
 * The print-letterhead trust line shown on the dashboard footer — e.g.
 * "Trust deed dated 14 March 2020 · IT-9999-2020".
 *
 * Degrades gracefully: when the deed date is absent (a name-only / governance-only
 * trust has no deed inception date — `deedDate` is null) we drop the "deed dated …"
 * clause rather than rendering a fabricated epoch date from `new Date(null)`
 * ("1 January 1970"). When the trust isn't loaded yet, a calm fallback. Pure —
 * unit-tested.
 */
export function trustLetterheadLine(
  trust: { deedDate: string | null; registration: string } | undefined,
): string {
  if (!trust) return 'Trust under administration';
  const deed = trust.deedDate
    ? `Trust deed dated ${new Date(trust.deedDate).toLocaleDateString('en-ZA', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })}`
    : 'Trust';
  return [deed, trust.registration].filter(Boolean).join(' · ');
}
